<form [formGroup]="form">
<div class="p-fluid formgrid grid">
    <hvl-form-item key="registryNumber" class="col-4" label="{{ 'hrPerPersonnel.registryNumber' | translate }}"  >
        <p-chips data-testid="picker-list-search_registryNumber_chips_1" (onAdd)="onRegNumAdd($event)" formControlName="registryNumber" separator="," placeholder="{{'hrPerPersonnel.regNumSepPlaceHolder' | translate}}"></p-chips>
    </hvl-form-item>
    <hvl-form-item *ngIf="isIdentityNumberRequired" key="identificationNumber" class="col-2"
                   label="{{ 'hrPerPersonnel.identificationNumber' | translate }}">
        <input data-testid="picker-list-search_identificationNumber_inp_1" formControlName="identificationNumber" id="{{ pageCode + '_identificationNumber' }}" maxlength="11"
               pInputText type="text" (keydown.enter)="onKeyDownEvent($event)" />
    </hvl-form-item>
    <hvl-form-item key="name" class="col-2" label="{{ 'hrPerCommon.name' | translate }}"  >
        <input data-testid="picker-list-search_name_inp_2" formControlName="name" id="{{ pageCode + '_name' }}" pInputText type="text" (keydown.enter)="onKeyDownEvent($event)"  toUppercase/>
    </hvl-form-item>
    <hvl-form-item key="surname" class="col-2" label="{{ 'hrPerCommon.surname' | translate }}"  >
        <input data-testid="picker-list-search_surname_inp_3" formControlName="surname" id="{{ pageCode + '_surname' }}" pInputText type="text" (keydown.enter)="onKeyDownEvent($event)" toUppercase/>
    </hvl-form-item>
    <hvl-form-item key="beginDate" class="col-1" label="{{ 'hrPerCommon.beginDate' | translate }}">
        <p-calendar
            data-testid="picker-list-search_startDate_dtpkr_1"
            id="{{ pageCode + 'startDate' }}"
            name="startDate"
            formControlName="startDate"
            [showIcon]="true"
            #beginDate
            appendTo="body"
            dateFormat="dd.mm.yy"
        ></p-calendar>
    </hvl-form-item>
    <hvl-form-item key="active" class="col-1"
                   label="{{ 'hrPerPersonnel.isActive' | translate }}">
        <p-dropdown uiKovanDropdown
                    data-testid="picker-list-search_active_ddl_1"
            [filter]="true"
            [disabled]="activeFieldDisable"
            [options]="enumTrueFalse"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            id="active"
            name="active"
            formControlName="active"
            placeholder="{{ 'placeHolder' | translate }}"
        ></p-dropdown>
    </hvl-form-item>
    <hvl-form-item *ngIf="showTopOrg" key="topOrganizationalUnitUuid" class="col-12 md:col-6 lg:col-2" label="{{ 'requirement.topOrganizationalUnit' | translate }}">
        <p-dropdown uiKovanDropdown
                    data-testid="picker-list-search_topOrganizationalUnitUuid_ddl_2"
                    [placeholder]="'placeHolder' | translate"
                    id="{{ pageCode + '_topOrganizationalUnitUuid' }}"
                    name="topOrganizationalUnitUuid"
                    appendTo="body"
                    [options]="topOrganizationList"
                    [optionValue]="'perObjectDefinitionId'"
                    [optionLabel]="'perObjectDefinitionText'"
                    formControlName="childOrgUnitId"
                    [showClear]="true"
                    (onFilter)="searchTopOrganization($event.filter)"
                    [filter]="true"
        >
        </p-dropdown>
    </hvl-form-item>
</div>
</form>
